import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import Moment from "react-moment";

// import { DraftButton } from "../../../../Components/Modal/supplier_app/DraftSelectionModel";
import DraftSelectionModal from "../../../../Components/Modal/supplier_app/DraftSelectionModel";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
// import ConstantsList from '../../../common/Constants';

//Components
import Layout from "../../../../Layout/Layout";
import CreatePOMasterModal from "../../../../Components/Modal/supplier_app/PO_Collabration/CreatePOMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";
import {
  addPoDetailNumber,
  getPurchaseOrder,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
// import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import configFromEnv from "../../../../services/configuration";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CancelModal from "../../../../Components/Modal/supplier_app/common/CancelModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import PurchaseOrder3WayMatchModal from "./PurchaseOrder3WayMatchModal";
// import {
//   addRfxNr,
//   quotationListInfo,
// } from "../../../../redux/feature/supplier_app/sourcingSlice";
import { useReactToPrint } from "react-to-print";
import PrintPoInvoice from "./PrintPoInvoice";
// import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import PrintPurchaseOrder from "./PrintPurchaseOrder";

const PurchaseOrder = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Material Order");

  // let userData = useSelector((state) => state?.user); // User Details from Store
  let purchaseOrderData = useSelector(
    (state) => state?.purchasing?.purchase_order,
  ); // get purchaseOrderData from Store
  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.purchase_order?.pagination,
  ); // User Details from Store
  // let config = useSelector((state) => state?.common?.data?.purchaseOrder); // config Details from Store
  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.PO?.module,
  ); // config Details from Store

  const [data, setData] = useState([]);

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const [chatId, setChatId] = useState(null);

  const [showDraftModal, setShowDraftModal] = useState(false);
  // const openDraftModal = () => setShowDraftModal(true);
  // Cancel: navigate back
  const handleCancelDraftModal = () => {
    setShowDraftModal(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  // const createRFQ = () => {
  //   setModalShow(true);
  // };

  const hideModal = () => {
    setModalShow(false);
  };

  const detailedPage = (poNumber) => {
    // console.log("poNumber", poNumber);
    dispatch(addPoDetailNumber(poNumber));
    navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE);
  };
  // const detailedPageQuotation = (quotationNr, qtnVersion) => {
  //   let obj = {
  //     quotationNr,
  //     qtnVersion,
  //   };
  //   dispatch(quotationListInfo(obj));
  //   navigate(Constants.SOURCING_QUOTATION_DETAILS);
  // };
  // const detailedPageBuyer = (rfxNr) => {
  //   dispatch(addRfxNr(rfxNr));
  //   navigate(Constants.SOURCING_BUYER_RFQ_DETAILS);
  // };
  // const loadInitialPOData = async () => {
  //   setData(purchaseOrderData?.data);
  // };

  // useEffect(() => {
  //   loadInitialPOData(); // fetch page 1 of users
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [purchaseOrderData]);

  const loadInitialPOData = () => {
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
    };

    dispatch(getPurchaseOrder(obj));
  };
  useEffect(() => {
    if (purchaseOrderData?.data) {
      setData(purchaseOrderData.data);
    }
  }, [purchaseOrderData]);
  //on page load
  useEffect(() => {
    getMasterData();
    loadInitialPOData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Modal Function */
  // eslint-disable-next-line
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    // {
    //   name: "Collaboration",
    //   cell: (row) => (
    //     <>
    //       <span className="iconTable">
    //         <button
    //           onClick={() => toggleChat(row.vendorCode)}
    //           title="Chat With the User"
    //           // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
    //         >
    //           <MessageCircle className="w-5 h-5" />
    //         </button>
    //       </span>

    //       <span>
    //         <i className="bi bi-collection-play iconTable"></i>
    //       </span>
    //       <span>
    //         <i className="bi bi-stack iconTable"></i>
    //       </span>
    //     </>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "Document Type",
    //   selector: (row) => row.purchasingDocumentCode,
    //   sortable: true,
    //   width: "220px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold">{row.purchasingDocumentType} </p>
    //     </div>
    //   ),
    // },
    // {
    //   name: "Purchase Type",
    //   selector: (row) => row.purchaseType || "--",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.purchaseType} </p>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Document",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "SAP PO ID",
      cell: (row) => (
        <>
          <TableStatusField status={"POID"} value={row.poID} />
        </>
      ),
      width: "140px",
    },
    // {
    //   name: "3Way-Match",
    //   cell: (row) => (
    //     <>
    //       {/* <button
    //       className="btnInfo"
    //       onClick={() => po3wayMatch(row.purchasingDocumentNr)}
    //     >
    //       Match
    //     </button> */}
    //       <div
    //         style={{ width: "100%" }}
    //         className="d-flex justify-content-center iconTable"
    //         onClick={() => po3wayMatch(row.purchasingDocumentNr)}
    //       >
    //         <i className="bi bi-mastodon"></i>
    //         {/* <img
    //               src="assets/img/newIcons/workflow.png"
    //               alt="attachments"
    //               style={{ width: "35px" }}
    //               className="mt-1"
    //               onClick={() => showStatusInfo(row.workflowTECHActionLogs)}
    //             /> */}
    //       </div>
    //     </>
    //   ),
    //   width: "100px",
    // },
    // Conditionally include the 'workflowActionLogs' column
    // ...(data?.some((row) => row.workflowActionLogs !== undefined)
    //   ? [
    //       {
    //         name: "Workflow log",
    //         selector: (row) => row.workflowActionLogs,
    //         cell: (row) => (
    //           <div
    //             style={{ width: "100%" }}
    //             className="d-flex justify-content-center iconTable"
    //           >
    //             <img
    //               src="assets/img/newIcons/workflow.png"
    //               alt="attachments"
    //               style={{ width: "35px" }}
    //               className="mt-1"
    //               onClick={() => showStatusInfo(row.workflowActionLogs)}
    //             />
    //           </div>
    //         ),
    //         sortable: true,
    //         width: "132px",
    //       },
    //     ]
    //   : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "100px",
    },
    // {
    //   name: "Attachments",
    //   selector: (row) => row.attachments,
    //   cell: (row) => (
    //     <div
    //       style={{ width: "100%" }}
    //       className="d-flex justify-content-center cursor-pointer"
    //       // onClick={()=>showViewInvoice(row)}
    //       onClick={() => handlePrintWithData(row)}
    //     >
    //       <img
    //         src="assets/img/newIcons/attached-file.png"
    //         alt="attachments"
    //         style={{ width: "25px" }}
    //         className="mt-1"
    //       />
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "130px",
    // },

    /*  {
      name: "Version",
      selector: (row) => row.version || "--",
      sortable: true,
      width: "100px",
    }, */
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row?.poApprovedStatus} />
        </>
      ),
      width: "180px",
    },
    // {
    //   name: "Date",
    //   selector: (row) => formatDateTime(row?.purchasingDocumentDate) || "--",
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "PO Value",
      cell: (row) => (
        <span className="d-flex justify-content-center m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.purchasingDocumentValue).toFixed(2))}
        </span>
      ),
      selector: (row) => row.purchasingDocumentValue || "--",
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "Currency ",
    //   cell: (row) => (
    //     <>
    //       <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
    //     </>
    //   ),
    //   selector: (row) => row.currency || "--",
    //   sortable: true,
    //   width: "110px",
    // },
    {
      name: "Supplier",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "140px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    // {
    //   name: "Payment Terms",
    //   cell: (row) => <>{row.paymentTerms}</>,
    //   selector: (row) => row.paymentTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Inco Terms",
    //   selector: (row) => row.incoTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Payment Terms",
    //   selector: (row) => row.paymentTermsCode,
    //   sortable: true,
    //   width: "150px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
    //     </div>
    //   ),
    // },
    // {
    //   name: "Inco Terms",
    //   selector: (row) => row.incoTermsCode,
    //   sortable: true,
    //   width: "150px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 ">{row.incoTerms} </p>
    //     </div>
    //   ),
    // },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Department",
      cell: (row) => <span>{row.departmentPODesc}</span>,
      width: "120px",
    },
    {
      name: "Cost Center ID",
      cell: (row) => <span>{row.costCenterId}</span>,
      width: "120px",
    },
    {
      name: "PO Type",
      cell: (row) => <span>{row.deptAndPOTypeDesc}</span>,
      width: "120px",
    },
    {
      name: "Print PO",
      cell: (row) => (
        <div
          className="d-flex justify-content-center align-items-center w-100 cursor-pointer"
          onClick={() => handlePrintPOWithData(row)}
        >
          <i className="bi bi-printer fs-5 text-secondary"></i>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "Company",
    //   cell: (row) => (
    //     <>
    //       <span> {row.companyCodeDesc || row.companyCode || ""} </span>
    //     </>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "PR Number",
    //   selector: (row) => row.items?.[0]?.purchaseReqDocumentNr || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "RFQ",
    //   cell: (row) => (
    //     <button className="btnInfo">{row.rfxCollectiveNr || "--"} </button>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "RFQ",
    //   cell: (row) => (
    //     <button
    //       className="btnInfo"
    //       onClick={() => detailedPageBuyer(row.rfxNr)}
    //     >
    //       {row.rfxNr || "--"}
    //     </button>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "Quotation",
    //   cell: (row) => (
    //     <button className="btnInfo">{row.quotationNumber || "--"}</button>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "Quotations",
    //   cell: (row) => {
    //     const firstQuotation = row.items
    //       ?.flatMap((item) => item.quotationDocument || [])
    //       .find((doc) => doc.quotationNr);

    //     return (
    //       <button
    //         className="btnInfo"
    //         onClick={() =>
    //           firstQuotation &&
    //           detailedPageQuotation(
    //             firstQuotation.quotationNr,
    //             firstQuotation.qtnVersion,
    //           )
    //         }
    //         title={`Quotation: ${firstQuotation?.quotationNr || "--"}`}
    //         disabled={!firstQuotation}
    //       >
    //         {firstQuotation?.quotationNr || "--"}
    //       </button>
    //     );
    //   },
    //   width: "150px",
    // },

    // {
    //   name: "Qtn Version",
    //   selector: (row) => row.rfqTechFocalPerson,
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Delivery Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.deliveredStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Invoice Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.invoicedStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Payment Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.paymentStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
  ];
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
// eslint-disable-next-line
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
 /*    {
      name: "Schedule Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    }, */
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Item Type",
      cell: (row) => <span>{row?.itemType} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.unitCode} </span>,
      width: "220px",
    },
    // {
    //   name: "Net Value",
    //   cell: (row) => <span>{row.netValue} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Delivery Date",
    //   cell: (row) => <span>{row.deliveryDate} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Purchase Req.",
    //   cell: (row) => <span>{row.requestNumber} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Purchase Req. Item Nr",
    //   cell: (row) => <span>{row.prItemNr} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Attachment",
    //   selector: (row) => row.attachmentId || "--",
    //   cell: (row) => (
    //     <div className="d-flex align-items-center">
    //       <div className="d-flex align-items-center pe-2">
    //         {(row.attachmentId && (
    //           <img
    //             src="assets/img/newIcons/attached-file.png"
    //             className="mt-1 attachmentIcon"
    //             alt="attachments"
    //             onClick={() => handleViewFile(row.attachmentId)}
    //           />
    //         )) ||
    //           "--"}
    //       </div>
    //     </div>
    //   ),
    //   width: "350px",
    // },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "PurchaseDocType",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const handlePageChange = (page) => {
    let obj = {
      page: page,
      per_page: getNewPerPage,
      queryName: "getMaterialPO",
      module: "PO",
      // vendorCode: userData?.data?.userId,
      // role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };

    dispatch(getPurchaseOrder(obj));
    setData(purchaseOrderData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      page: page,
      per_page: newPerPage,
      queryName: "getMaterialPO",
      module: "PO",
      // vendorCode: userData?.data?.userId,
      // role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getPurchaseOrder(obj));
    setData(purchaseOrderData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      module: "PO",
      queryName: "getMaterialPO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseOrder(obj));
  };

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  // eslint-disable-next-line
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled",
    );
    setSelectedRows(validRows);
  };
  const [po3wayMatchModalShow, setpo3wayMatchModalShow] = useState(false);
  const [getPoNumber, setPoNumber] = useState(false);

  const po3wanyMatchhideModal = () => {
    setpo3wayMatchModalShow(false);
  };
  // eslint-disable-next-line
  const po3wayMatch = (poNumber) => {
    setpo3wayMatchModalShow(true);
    setPoNumber(poNumber);
  };

  //po print invocie
  const contentRef = useRef(null);
  const contentRefPO = useRef(null);
  const [getLoadingAdvice, setLoadingAdvice] = useState([]);
  // useReactToPrint declared at top level

  // const handlePrint = useReactToPrint({
  //   contentRef,
  //   // documentTitle: `loadingAdvice_${getLoadingAdvice?.documentNumber || ""}`,
  // });

  const handlePrintPO = useReactToPrint({
    contentRef: contentRefPO,
  });

  const handlePrintPOWithData = async (row) => {
    const toastId = toast.loading("Fetching PO print details...", {
      position: "top-right",
    });
    try {
      const companyId =
        row.companyCodeCode ||
        row.companyAddressCode ||
        (row.companyCode && row.companyCode.split(" - ")[0]);
      const vendorId = row.vendorCode;
      const companyPromise = companyId
        ? ItemService.generateCustomerQuery({
            queryName: "Get_CompanyMaster_Details",
            documentNumber: companyId,
          })
        : Promise.resolve(null);
      const vendorPromise = vendorId
        ? ItemService.getUserDetail({
            userId: vendorId,
          })
        : Promise.resolve(null);
      const [companyRes, vendorRes] = await Promise.all([
        companyPromise,
        vendorPromise,
      ]);
      let companyAddressInfo = "";
      let companyMobile = "";
      let companyGST = "";
      let companyEmail = "";
      if (companyRes?.status === 200 && companyRes?.data?.[0]) {
        const comp = companyRes.data[0];
        companyAddressInfo = [comp.address, comp.address2, comp.cityPostalCode]
          .filter(Boolean)
          .join(" ");
        companyMobile =
          comp.mobileNr || comp.contactDetails?.[0]?.contactNumber || "";
        companyGST = comp.gstNumebr || "";
        companyEmail = comp.contactDetails?.[0]?.contactEmail || "";
      }
      let vendorAddressInfo = "";
      let vendorMobile = "";
      let vendorGST = "";
      let vendorEmailInfo = "";
      if (vendorRes?.status === 200 && vendorRes?.data) {
        const vend = vendorRes.data;

        const addrParts = [];
        if (vend.address) addrParts.push(vend.address);
        if (vend.address2) addrParts.push(vend.address2);
        if (vend.city) {
          if (vend.cityPostalCode) {
            addrParts.push(`${vend.city} - ${vend.cityPostalCode}`);
          } else {
            addrParts.push(vend.city);
          }
        } else if (vend.cityPostalCode) {
          addrParts.push(vend.cityPostalCode);
        }
        vendorAddressInfo = addrParts.join(" ");
        vendorMobile = vend.contactDetails?.[0]?.contactNumber || "";
        vendorEmailInfo = vend.email || "";
        const gstDoc = vend?.certifications?.find(
          (cert) =>
            cert?.documentType && cert.documentType.split(" - ")[0] === "101",
        );
        vendorGST = gstDoc?.documentNumber || "";
      }
      const enrichedData = {
        ...row,
        addressDl: companyAddressInfo,
        mobileNoDl: companyMobile,
        gstInDl: companyGST,
        emailDl: companyEmail,
        vendorAddress: vendorAddressInfo,
        vendorMobileNo: vendorMobile,
        vendorGSTNo: vendorGST,
        vendorEmail: vendorEmailInfo,
      };
      setLoadingAdvice(enrichedData);
      toast.dismiss(toastId);
      setTimeout(() => {
        handlePrintPO();
      }, 500);
    } catch (error) {
      console.error("Error fetching print details:", error);
      toast.error("Failed to load some print details.", { id: toastId });

      setLoadingAdvice(row);
      setTimeout(() => {
        handlePrintPO();
      }, 500);
    }
  };

  // const handlePrintWithData = (row) => {
  //   setLoadingAdvice(row);

  //   // Wait for state updates before printing
  //   setTimeout(() => {
  //     handlePrint();
  //   }, 500);
  // };

  //chat
  // const toggleChat = (groupId) => {
  //   // Toggle the same PR closes the chat
  //   if (chatId === groupId) {
  //     setChatId(null);
  //   } else {
  //     setChatId(groupId);
  //   }
  // };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle"> Material Purchase Order</h2>
                <p className="subText">
                  Lists of Material Purchase Order and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>

            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MT</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Material PO List</span>
                      <span className="subHeaderTitle">
                        View of Material PO and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/*  <Col xs={3} md={3} lg={3} className="">
                        <DraftButton
                          draftType={"MANUAL_PO"}
                          onClick={openDraftModal}
                        />
                      </Col> */}
                      {/* {config?.createManualPOBtn &&
                        (userData?.data?.category === "VENDOR" ? (
                          ""
                        ) : (
                          <Col xs={3} md={3} lg={3} className="">
                            <button
                              className="btnTable"
                              onClick={() => createRFQ()}
                            >
                              <i className="bi bi-clipboard-check"></i> Manual
                              PO
                            </button>
                          </Col>
                        ))} */}

                      {/* {config?.deletion &&
                        (userData?.data?.category === "VENDOR" ? (
                          ""
                        ) : (
                          <Col xs={3} md={3} lg={3} className="">
                            <button
                              className="btnTable"
                              onClick={cancelModalShow}
                              disabled={
                                getSelectedRows.length > 0 ? false : true
                              }
                            >
                              <i className="bi bi-x-circle"></i> Cancel
                            </button>
                          </Col>
                        ))} */}

                      {/* {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      )} */}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 5]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <div style={{ display: "none" }}>
          <PrintPoInvoice ref={contentRef} data={getLoadingAdvice} />
        </div>
        <div style={{ display: "none" }}>
          <PrintPurchaseOrder ref={contentRefPO} data={getLoadingAdvice} />
        </div>
      </Row>

      <CreatePOMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdowndata={getPurchaseDocType}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CancelModal
        title="Cancel the Purchase Order"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      <PurchaseOrder3WayMatchModal
        show={po3wayMatchModalShow}
        onHide={() => po3wanyMatchhideModal()}
        getPoNumber={getPoNumber}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <DraftSelectionModal
        show={showDraftModal}
        onHide={handleCancelDraftModal}
        draftType={"MANUAL_PO"}
        toNavigate={Constants.POCOLLABRATION_PURCHASE_ORDER_CREATION}
      />

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default PurchaseOrder;
